import type { GridColumnsInput } from '@thinkalpha/ui-table/types/column';

export const newsGridColumns: GridColumnsInput = {
    columns: ['publishedAt', 'symbol', 'headline', 'mentioned'].map((columnId) => ({
        columnId,
        fieldId: 'news',
        hostedRenderer: true,
    })),
    columnState: [
        { columnId: 'publishedAt', order: 0, visible: true, width: 95, pinned: 'left' },
        { columnId: 'symbol', order: 1, visible: true, width: 55, pinned: 'left' },
        { columnId: 'headline', order: 2, visible: true, width: 650 },
        { columnId: 'mentioned', order: 3, visible: true, width: 125, pinned: 'right' },
    ],
    columnDisplay: [
        { columnId: 'publishedAt', label: 'Published At', displaySettings: [] },
        { columnId: 'symbol', label: 'Symbol', displaySettings: [] },
        { columnId: 'headline', label: 'Headline', displaySettings: [], ellipsis: true },
        { columnId: 'mentioned', label: 'All Mentioned', displaySettings: [] },
    ],
};
